export default __webpack_public_path__ + "static/media/maya-1.b58b956a.JPG";